var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconawesomeFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.287,
    height: 21.075,
    viewBox: "0 0 11.287 21.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook-f",
    "data-name": "Icon awesome-facebook-f",
    d: "M12.157,11.855l.585-3.814H9.083V5.566A1.907,1.907,0,0,1,11.233,3.5H12.9V.258A20.289,20.289,0,0,0,9.943,0C6.93,0,4.96,1.827,4.96,5.134V8.041H1.609v3.814H4.96v9.22H9.083v-9.22Z",
    transform: "translate(-1.609)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconawesomeFacebook);
export default __webpack_public_path__ + "static/media/Icon awesome-facebook.7514807641db2a986795d503ee7126b9.svg";
export { ForwardRef as ReactComponent };